var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.075 3.59774C16.918 3.44191 16.7212 3.33236 16.506 3.28113C16.2908 3.2299 16.0657 3.23898 15.8554 3.30737L3.71761 7.35606C3.4925 7.42739 3.29358 7.56383 3.14597 7.74814C2.99836 7.93246 2.90868 8.15639 2.88826 8.39164C2.86785 8.6269 2.9176 8.86293 3.03125 9.06992C3.1449 9.27691 3.31734 9.44558 3.52679 9.55463L8.56277 12.0436L11.0517 17.0961C11.1518 17.2939 11.3048 17.46 11.4938 17.5757C11.6829 17.6915 11.9003 17.7523 12.122 17.7516H12.2049C12.4423 17.7341 12.6689 17.6456 12.8553 17.4977C13.0417 17.3497 13.1794 17.1491 13.2503 16.9219L17.3571 4.81733C17.4304 4.6082 17.4428 4.38254 17.3929 4.16663C17.3429 3.95072 17.2327 3.75343 17.075 3.59774ZM4.23199 8.50097L14.8266 4.96667L8.9444 10.8489L4.23199 8.50097ZM12.18 16.4407L9.82383 11.7283L15.7061 5.84609L12.18 16.4407Z",
    fill: "#E86747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSend);
export default __webpack_public_path__ + "static/media/nav_send.2db1cd4322fdbd306d363b6391b3d883.svg";
export { ForwardRef as ReactComponent };